import { useState, useEffect } from 'react'
import { FiServer, FiRefreshCw, FiCheckCircle, FiAlertCircle, FiDatabase, FiDroplet } from 'react-icons/fi'
import api from '../utils/api'

const fmtTime = (iso) => {
  if (!iso) return '—'
  try {
    const d = new Date(iso)
    return d.toLocaleString('tr-TR', { dateStyle: 'short', timeStyle: 'medium' })
  } catch { return iso }
}

const fmtAge = (iso) => {
  if (!iso) return ''
  const d = new Date(iso)
  const dakika = Math.floor((Date.now() - d.getTime()) / 60000)
  if (dakika < 60) return `${dakika} dk önce`
  if (dakika < 1440) return `${Math.floor(dakika / 60)} saat önce`
  return `${Math.floor(dakika / 1440)} gün önce`
}

export default function SorguGecmisi() {
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(true)

  const load = async () => {
    setLoading(true)
    try {
      const { data } = await api.get('/sorgu-gecmisi')
      setData(data)
    } catch (e) { console.error(e) }
    setLoading(false)
  }
  useEffect(() => { load() }, [])

  return (
    <div className="p-3 md:p-5 max-w-7xl mx-auto">
      <div className="flex items-center justify-between mb-4 sticky top-0 z-10 -mx-3 md:-mx-5 px-3 md:px-5 py-3 bg-gray-50/95 dark:bg-gray-900/95 backdrop-blur border-b border-gray-200 dark:border-gray-700">
        <div>
          <h1 className="text-lg md:text-xl font-bold flex items-center gap-2 text-gray-800 dark:text-gray-100">
            <FiServer /> Sorgu Geçmişi
          </h1>
          <p className="text-[11px] text-gray-500">Veritabanı bağlantıları + Tank scrape durumu · {data && fmtTime(data.generated_at)}</p>
        </div>
        <button onClick={load} disabled={loading}
          className={`p-2 rounded-lg ${loading ? 'text-primary-400' : 'text-gray-500 hover:text-primary-600 hover:bg-primary-50 dark:hover:bg-gray-800'}`}>
          <FiRefreshCw size={16} className={loading ? 'animate-spin' : ''} />
        </button>
      </div>

      {!data && loading && <div className="text-center text-gray-400 py-12">Yükleniyor...</div>}

      {data && (
        <>
          {/* DB BAĞLANTILARI */}
          <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-100 dark:border-gray-700 p-4 mb-4">
            <h2 className="text-sm font-semibold text-gray-700 dark:text-gray-200 mb-3 flex items-center gap-2">
              <FiDatabase /> Veritabanı Bağlantıları ({data.db_baglantilari?.length || 0})
            </h2>
            <div className="overflow-auto">
              <table className="w-full text-xs">
                <thead className="bg-gray-50 dark:bg-gray-900/50">
                  <tr>
                    <th className="px-2 py-1.5 text-left font-medium text-gray-600 dark:text-gray-300">Durum</th>
                    <th className="px-2 py-1.5 text-left font-medium text-gray-600 dark:text-gray-300">Veri Kaynağı</th>
                    <th className="px-2 py-1.5 text-left font-medium text-gray-600 dark:text-gray-300">Sunucu</th>
                    <th className="px-2 py-1.5 text-left font-medium text-gray-600 dark:text-gray-300">Tip</th>
                    <th className="px-2 py-1.5 text-right font-medium text-gray-600 dark:text-gray-300">Cevap</th>
                    <th className="px-2 py-1.5 text-left font-medium text-gray-600 dark:text-gray-300">Son Başarılı</th>
                    <th className="px-2 py-1.5 text-left font-medium text-gray-600 dark:text-gray-300">Son Hata</th>
                  </tr>
                </thead>
                <tbody>
                  {data.db_baglantilari?.map(r => (
                    <tr key={r.ds_id} className={`border-b border-gray-50 dark:border-gray-700 ${r.durum === 'OK' ? '' : 'bg-red-50/40 dark:bg-red-900/10'}`}>
                      <td className="px-2 py-1.5">
                        {r.durum === 'OK'
                          ? <span className="inline-flex items-center gap-1 text-green-600"><FiCheckCircle size={14}/> OK</span>
                          : <span className="inline-flex items-center gap-1 text-red-600"><FiAlertCircle size={14}/> HATA</span>}
                      </td>
                      <td className="px-2 py-1.5 font-medium">{r.ad}</td>
                      <td className="px-2 py-1.5 text-gray-500 font-mono text-[10px]">{r.sunucu}</td>
                      <td className="px-2 py-1.5 text-gray-500">{r.tip}</td>
                      <td className="px-2 py-1.5 text-right tabular-nums">{r.sure_ms} ms</td>
                      <td className="px-2 py-1.5 text-[10px]">
                        <div>{fmtTime(r.son_basarili)}</div>
                        {r.son_basarili && <div className="text-gray-400">{fmtAge(r.son_basarili)}</div>}
                      </td>
                      <td className="px-2 py-1.5 text-[10px]">
                        {r.hata && <div className="text-red-600 truncate max-w-xs" title={r.hata}>{r.hata.substring(0, 60)}</div>}
                        {r.son_hata && !r.hata && (
                          <div className="text-gray-400">
                            <div>{fmtTime(r.son_hata)}</div>
                            <div>{fmtAge(r.son_hata)}</div>
                          </div>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          {/* TANK SCRAPE */}
          <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-100 dark:border-gray-700 p-4">
            <h2 className="text-sm font-semibold text-gray-700 dark:text-gray-200 mb-3 flex items-center gap-2">
              <FiDroplet /> Tank Doluluk Scrape Durumu
            </h2>
            <p className="text-[11px] text-gray-500 mb-3">
              Tank verisi 30 dakikada bir 3 istasyondan toplanır. CSV son güncelleme: <span className="font-mono">{fmtTime(data.tank_scrape?.csv_dosya_mtime)}</span>
            </p>
            <div className="overflow-auto">
              <table className="w-full text-xs">
                <thead className="bg-gray-50 dark:bg-gray-900/50">
                  <tr>
                    <th className="px-2 py-1.5 text-left font-medium text-gray-600 dark:text-gray-300">Durum</th>
                    <th className="px-2 py-1.5 text-left font-medium text-gray-600 dark:text-gray-300">İstasyon</th>
                    <th className="px-2 py-1.5 text-right font-medium text-gray-600 dark:text-gray-300">Tank Sayısı</th>
                    <th className="px-2 py-1.5 text-left font-medium text-gray-600 dark:text-gray-300">Son Başarılı Çekim</th>
                    <th className="px-2 py-1.5 text-left font-medium text-gray-600 dark:text-gray-300">Son Hata</th>
                  </tr>
                </thead>
                <tbody>
                  {data.tank_scrape?.istasyonlar?.map((t, i) => (
                    <tr key={i} className={`border-b border-gray-50 dark:border-gray-700 ${t.durum !== 'OK' ? 'bg-red-50/40 dark:bg-red-900/10' : ''}`}>
                      <td className="px-2 py-1.5">
                        {t.durum === 'OK'
                          ? <span className="inline-flex items-center gap-1 text-green-600"><FiCheckCircle size={14}/> OK</span>
                          : <span className="inline-flex items-center gap-1 text-red-600"><FiAlertCircle size={14}/> HATA</span>}
                      </td>
                      <td className="px-2 py-1.5 font-medium">{t.istasyon}</td>
                      <td className="px-2 py-1.5 text-right tabular-nums">{t.tank_sayi}</td>
                      <td className="px-2 py-1.5 text-[10px]">
                        <div>{fmtTime(t.son_basarili)}</div>
                        {t.son_basarili && <div className="text-gray-400">{fmtAge(t.son_basarili)}</div>}
                      </td>
                      <td className="px-2 py-1.5 text-[10px]">
                        {t.son_hata ? (
                          <>
                            <div className="text-red-600">{fmtTime(t.son_hata)}</div>
                            <div className="text-gray-400">{fmtAge(t.son_hata)}</div>
                            {t.son_hata_mesaj && <div className="text-red-500 mt-0.5" title={t.son_hata_mesaj}>{t.son_hata_mesaj}</div>}
                          </>
                        ) : <span className="text-gray-300">—</span>}
                      </td>
                    </tr>
                  ))}
                  {data.tank_scrape?.eksik_istasyonlar?.map((adi, i) => (
                    <tr key={`miss-${i}`} className="border-b border-gray-50 bg-red-50/40 dark:bg-red-900/10">
                      <td className="px-2 py-1.5"><span className="inline-flex items-center gap-1 text-red-600"><FiAlertCircle size={14}/> EKSİK</span></td>
                      <td className="px-2 py-1.5 font-medium">{adi}</td>
                      <td className="px-2 py-1.5 text-right">0</td>
                      <td className="px-2 py-1.5 text-[10px] text-red-600">Bu istasyondan hiç veri gelmemiş — scraper login yapamıyor olabilir</td>
                      <td className="px-2 py-1.5"></td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </>
      )}
    </div>
  )
}
